import { formatNumber } from './formatNumber';

export const formatStackedNumbers = (num: number) => {
  if (num < 10000) {
    return formatNumber(num);
  }

  const formatter = new Intl.NumberFormat('en', {
    notation: 'compact',
    maximumFractionDigits: 2,
  });
  return formatter.format(num);
};
